// This file is automatically generated. Do not edit this file directly.
// Edit the template in the codegen repo instead.

import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tags-select"
export default class extends Controller {
  static targets = ["dropdown", "input"];

  // Action appelée quand on clique en dehors du composant
  clickOutside(event) {
    if (this.dropdownTarget.classList.contains("hidden")) return;
    this.hideDropdown();
  }

  // Affiche ou cache le dropdown
  toggleDropdown(event) {
    // Si le clic vient de l'input, on empêche l'événement de "remonter" au wrapper
    // pour éviter que la méthode soit appelée deux fois (une fois pour l'input, une fois pour le wrapper)
    // ce qui annulerait l'ouverture/fermeture du dropdown.
    if (this.inputTarget.contains(event.target)) {
      event.stopPropagation();
    }

    this.dropdownTarget.classList.toggle("hidden");
    if (!this.dropdownTarget.classList.contains("hidden")) {
      this.inputTarget.focus();
    }
  }

  hideDropdown() {
    this.dropdownTarget.classList.add("hidden");
  }
}